/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
/**
 * Generate a unique system reference number for assignments
 * Format: #ASN-YEAR-HHMMSS
 * Example: #ASN-2024-143052 (for 2:30:52 PM)
 */
export const generateSystemReferenceNumber = () => {
  const now = new Date();
  const year = now.getFullYear();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `ASN-${year}-${hours}${minutes}${seconds}`;
};

/**
 * Generate a system reference number with custom prefix
 * @param {string} prefix - Custom prefix (default: 'ASN')
 * @returns {string} System reference number
 */
export const generateSystemReferenceNumberWithPrefix = (prefix = 'ASN') => {
  const now = new Date();
  const year = now.getFullYear();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `#${prefix}-${year}-${hours}${minutes}${seconds}`;
};

/**
 * Validate system reference number format
 * @param {string} systemReferenceNumber - System reference number to validate
 * @returns {boolean} True if valid format
 */
export const isValidSystemReferenceNumber = (systemReferenceNumber) => {
  const pattern = /^#[A-Z]{2,5}-\d{4}-\d{6}$/;
  return pattern.test(systemReferenceNumber);
};
